import { z } from "zod";
import { AddressSchema } from "./address";

export const AccountBaseSchema = z.object({
  name: z.string().min(1, "Name is required"),
  company_name: z.string().optional(),
  email: z.string().email("Please enter a valid email address"),
  phone: z
    .string()
    .regex(
      /^\(?[0-9]{3}\)?\s?[0-9]{3}\s?\-?\s?[0-9]{4}$/,
      "Please enter a valid US phone number",
    ),
  ...AddressSchema.shape,
});

export const AccountSchema = AccountBaseSchema;

export type AccountFormData = z.infer<typeof AccountSchema>;
